import { render } from "./Auctioneer.vue?vue&type=template&id=8383da26"
import script from "./Auctioneer.vue?vue&type=script&lang=js"
export * from "./Auctioneer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aron/Herd/de-veense-veiling/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__